<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Object,
    default: () => {},
  },
})
// console.log(props.listData);
const myEcharts = ref(null);

onMounted(() => {
  // let data = [
  //   { value: 287.5, name: "2023年全县生产总值" },
  //   { value: 54.57, name: "第一产业增加值" },
  //   { value: 93.51, name: "第二产业增加值" },
  //   { value: 139.44, name: "第三产业增加值" },
  // ];
  initChart(props.listData);
});

function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);
  console.log(listData)
  var liftMonthDtoList=[
    {month:"第一季度",thisYear:30,lastYear:33},
    {month:"第二季度",thisYear:32,lastYear:38},
    {month:"第三季度",thisYear:31,lastYear:30},
    {month:"第四季度",thisYear:30,lastYear:36},
  ]
  var data=[],year=[],lastYear=[];
  liftMonthDtoList.forEach((item) => {
    data.push(item.month);
    year.push(Number(item.thisYear).toFixed(2));
    lastYear.push(Number(item.lastYear).toFixed(2));
  })

  const option= {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      top: '14%',
      right: '3%',
      left: '7%',
      bottom: '20%'
    },
    legend: {
      top: '3%',
      right:'3%',
      itemWidth: 17,
      itemHeight: 10,
      textStyle: {
        color: "#ffffff",
        fontSize: 15
      },
      data: ['消费金额', '充值金额'],

    },
    xAxis: [{
      type: 'category',
      data: data,
      axisLine: {
        lineStyle: {
          color: 'rgba(255,255,255,1)'
        }
      },
      axisLabel: {
        margin: 10,
        color: '#e2e9ff',
      },
    }],
    yAxis: [{
      name: '元³',
      boundaryGap: ['0%', '20%'],
      nameTextStyle: {
        verticalAlign: 'middle',
        align: "right"
      },
      axisLabel: {
        formatter: '{value}',
        color: '#e2e9ff',
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: 'rgba(255,255,255,1)'
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255,255,255,0.12)'
        }
      }
    }],
    series: [{
      name: "消费金额",
      type: 'bar',
      data: year,
      barWidth: '15',
      itemStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#28FFF2' // 0% 处的颜色
        }, {
          offset: 1,
          color: '#0B2C33' // 100% 处的颜色
        }], false),
        shadowColor: 'rgba(0,160,221,1)',
      }
    }, {
      name: "充值金额",
      type: 'bar',
      data: lastYear,
      barWidth: '15',
      itemStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#28A6FF' // 0% 处的颜色
        }, {
          offset: 1,
          color: '#0B2336' // 100% 处的颜色
        }], false),

        shadowColor: 'rgba(0,160,221,1)',
        // shadowBlur: 4,
      }
    }]
  };// 将你的ECharts配置项放在这里
    chartInstance.setOption(option, true);
}
  window.addEventListener("resize", () => {
    chartInstance.resize();
  });

</script>
<style lang="less"></style>
